import { Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/layout/AppShell";
import { WizardRouteGuard } from "@/components/wizard/WizardRouteGuard";
import { DonePage } from "@/pages/DonePage";
import { LiveDashboardPage } from "@/pages/LiveDashboardPage";
import { ReviewPage } from "@/pages/ReviewPage";
import { SecretsPage } from "@/pages/SecretsPage";

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<LiveDashboardPage />} />
        <Route path="live" element={<Navigate to="/" replace />} />
        <Route path="wizard" element={<WizardRouteGuard />}>
          <Route index element={<Navigate to="review" replace />} />
          <Route path="review" element={<ReviewPage />} />
          <Route path="overview" element={<Navigate to="review" replace />} />
          <Route path="welcome" element={<Navigate to="review" replace />} />
          <Route path="prerequisites" element={<Navigate to="review" replace />} />
          <Route path="preview" element={<Navigate to="review" replace />} />
          <Route path="apply" element={<Navigate to="review" replace />} />
          <Route path="secrets" element={<SecretsPage />} />
          <Route path="done" element={<DonePage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
